export const ContabilFechamento = {
    // Letra A:
    ACOES: 'Ações',
    ANO_CONTABIL: 'Ano contábil',

    // Letra B:
    // Letra C:
    CONTABIL: 'Contábil',

    // Letra D:
    DATA_INICIAL: 'Data inicial',
    DATA_FIM: 'Data fim',

    // Letra E:
    // Letra F:
    // Letra G:
    // Letra H:
    // Letra I:
    // Letra J:
    // Letra K:
    // Letra L:
    LISTAR_PERIODOS_CONTABEIS: 'Listar períodos contábeis',

    // Letra M:
    MES_REFERENCIA: 'Mês de referência',

    // Letra N:
    // Letra O:
    // Letra P:
    PAGE_TITLE: 'Fechamento contábil',

    // Letra Q:
    // Letra R:
    // Letra S:
    STATUS: 'Status',

    // Letra T:
    // Letra U:
    // Letra V:
    // Letra X:
    // Letra Y:
    // Letra Z:
}